import type { ReactNode } from 'react'
import { AppFooter } from './components/AppFooter'
import { Logo } from './components/Logo'
import { cn } from '@/shared/lib/utils'

interface AuthShellProps {
  children: ReactNode
  infoLayout?: boolean
}

export function AuthShell({ children, infoLayout = false }: AuthShellProps) {
  return (
    <div className="flex min-h-screen w-full flex-col bg-white">
      <main className="flex flex-1 items-center justify-center px-4 py-16">
        <div className={cn(infoLayout ? 'w-full max-w-136' : 'w-85')}>
          <div className={cn('flex', infoLayout && 'justify-center')}>
            <Logo className="mb-12" />
          </div>

          {children}
        </div>
      </main>
      <AppFooter showLanguageSelector />
    </div>
  )
}
